import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useLearningUserStore = defineStore('learningUser', () => {
  const _userInfo = ref({})
  const _registerInfo = ref({})
  const _accountInfo = ref({})
  const alreadyEntry = ref(false)
  const trainable = ref(true)

  const userInfo = computed(() => {
    return _userInfo.value
  })

  const registerInfo = computed(() => {
    return _registerInfo.value
  })

  const accountInfo = computed(() => {
    return _accountInfo.value
  })

  const setUserInfo = (obj) => {
    _userInfo.value = obj
    if (obj.flags && obj.flags.includes('notTrainable')) {
      trainable.value = false
    } else {
      trainable.value = true
    }
    console.log('serUserInfo', obj, _userInfo.value)
  }

  const setRegisterInfo = (obj) => {
    // TODO なぜかリロードすると消えてしまう
    _registerInfo.value = JSON.parse(JSON.stringify(obj))
  }

  const setAccountInfo = (obj) => {
    // TODO なぜかリロードすると消えてしまう
    _accountInfo.value = JSON.parse(JSON.stringify(obj))
  }
  
  const setAlreadyEntry = (bool) => {
    alreadyEntry.value = bool
  }

  return {
    userInfo,
    registerInfo,
    accountInfo,
    alreadyEntry,
    trainable,
    setUserInfo,
    setRegisterInfo,
    setAccountInfo,
    setAlreadyEntry
  }
}, { persist: true })
